import './App.css';
import React, { createRef } from 'react';
import Header from './Components/Header'
import HomePage from './Components/HomePage'
import Privacy from './Components/Privacy'
import StandardizeProductReportCard from './Components/Feature/StandardizeProductReportCard'
import InstantInsurancePlanning from './Components/Feature/InstantInsurancePlanning'
import AiBioPersonalSolution from './Components/Feature/AiBioPersonalSolution'
import Footer from './Components/Footer'
import AboutUsMain from './Components/AboutUs/AboutUsMain'
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import i18n from './i18n';
import ScrollToTop from './Components/ScrollToTop'

function App() {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#25D366",
      },
      secondary: {
        main: "#FFFFFF"
      }
    },
  });

  return (
    <Router>
      <ScrollToTop />
      <ThemeProvider theme={theme}>
        <Header />
        <Switch>
          <Route exact path="/">
            <HomePage />
          </Route>
          <Route path="/standardize-product-report-card">
            <StandardizeProductReportCard />
          </Route>
          <Route path="/instant-insurance-planning">
            <InstantInsurancePlanning />
          </Route>
          <Route path="/ai-bio-personal-solution">
            <AiBioPersonalSolution />
          </Route>
          <Route path="/about-us-main">
            <AboutUsMain />
          </Route>
        </Switch>
        <Footer />
      </ThemeProvider>
    </Router>

  );
}

export default App;
